import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { BlocklistAction } from "../actions";

export default class BlocklistMiddleware {
  static *getBlocklist({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/block-profile/sender?lsort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(BlocklistAction.getBlocklistSuccess(res.data?.data));
      } else {
        yield put(BlocklistAction.getBlocklistFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(BlocklistAction.getBlocklistFailure());
    }
  }
  static *deleteBlocklist({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Delete(
        `/activity/block-profile/${payload.blockedId}`
      );
      if (res.status === 200) {
        yield put(BlocklistAction.deleteBlocklistSuccess(res.data.data));
        message.success(res.data?.message);
      } else {
        message.error(res.data?.message);
        yield put(BlocklistAction.deleteBlocklistFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(BlocklistAction.deleteBlocklistFailure());
    }
  }
  static *updateBlocklist({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(
        `/activity/block-profile`,
        payload
      );
      if (res.status === 200) {
        message.success(res.data?.message);
        yield put(BlocklistAction.updateBlocklistSuccess(res.data.data));
      } else {
        message.error(res.data?.message);
        yield put(BlocklistAction.updateBlocklistFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(BlocklistAction.updateBlocklistFailure());
    }
  }
}
